import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import * as mixins from 'view/styles/mixins';
import { sizes } from 'view/styles/sizes-viewport';

export const RecentFormContainer = styled.div`
    ${mixins.borderBox};
    max-width: ${sizes.small}px;
    padding: 0 ${token('space.600', '48px')};
    margin: 0 auto;
    width: 100%;
`;
